import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { cameraPos1, SCENE_OBJ_NAMES } from './constants';
import { cameraPositionAnimation, createCamera, setCameraData } from './camera';
import { addEventListeners } from './eventListeners';
import { roomsManagementHub } from './roomsManagementHub';
import { animationService } from './animationService';
import { spinState } from './spin';
import { isMobile, loadingStore } from '@pascal/pascal-core';

export const sceneObjects = new Map();
let renderer;

export const loadedState = {
  hdr: true,
  roomGlb: false,
};

const initScene = async (roomName) => {
  if (renderer) {
    cameraPositionAnimation(sceneObjects.get(SCENE_OBJ_NAMES.camera), cameraPos1);
    roomsManagementHub.addRouletteGLBModel(sceneObjects.get(SCENE_OBJ_NAMES.scene), roomName);
    animationService.clearAnimations();
    spinState.setCanSpin(true);
    return;
  }

  await roomsManagementHub.downloadRoomsGlb();
  loadedState.roomGlb = true;

  const scene = new THREE.Scene();
  sceneObjects.set(SCENE_OBJ_NAMES.scene, scene);

  const camera = createCamera();
  sceneObjects.set(SCENE_OBJ_NAMES.camera, camera);

  renderer = createRenderer();

  // createControls(camera, renderer.domElement);

  roomsManagementHub.addRouletteGLBModel(scene, roomName);
  addEventListeners();

  startRendering(scene, camera, renderer);
  setCameraData(camera, cameraPos1);

  setTimeout(() => {
    loadingStore.updateLoading({ isPixiLoaded: true, isAssetsIsLoaded: true });
  }, 1000);

  return scene;
};

const createRenderer = () => {
  const renderer = new THREE.WebGLRenderer({
    canvas: document.getElementById('roulette-canvas'),
    antialias: true,
  });
  renderer.setPixelRatio(1.5);
  return renderer;
};

const createControls = (camera, domElement) => {
  const controls = new OrbitControls(camera, domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  return controls;
};

const startRendering = (scene, camera, renderer) => {
  let lastFrameTime = 0;
  const fpsInterval = isMobile() ? 1000 / 30 : 1000 / 60;

  function render(currentTime) {
    requestAnimationFrame(render);

    const elapsed = currentTime - lastFrameTime;

    if (elapsed > fpsInterval) {
      lastFrameTime = currentTime - (elapsed % fpsInterval);

      // Rendering the scene
      renderer.render(scene, camera);
    }
  }

  render();
};

export const rouletteGame = (roomName) => {
  initScene(roomName);
};
